import { getBaseFeature } from '@/assets/style/variable'

const styObj = {
  default: {
    '--wa-save-btn-active-bg': '#a338fc',
    '--wa-save-btn-active-color': '#ffffff',
  },

  kiko: {
    '--wa-save-btn-active-bg': '#ffe242',
    '--wa-save-btn-active-color': '#000000',
  },
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        if (styObj[this.packageName]) {
          return { ...getBaseFeature(), ...styObj[this.packageName] }
        }
        return { ...getBaseFeature(), ...styObj.default }
      }
      return { ...getBaseFeature() }
    },
  },
}
